import React from 'react';
import PropTypes from 'prop-types';

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Grid from "@mui/material/Grid";

import {black500, greyishBlue500} from "assets/jss/main";
import {ReactComponent as CloseIcon} from "assets/img/wms/close.svg";

Popup.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    icon: PropTypes.element,
    isMobile: PropTypes.bool,
    hideCloseIcon: PropTypes.bool,
    strictOnclose: PropTypes.bool,
};

function Popup({open, onClose, title, subtitle, icon, isMobile = false, sx, hideCloseIcon = false, strictOnclose = false, ...props}) {
    return (
        <Dialog
            open={open}
            onClose={strictOnclose ? (event, reason) => {
                if(reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                    onClose();
                }
            } : onClose}
            sx={{
                '& .MuiPaper-root ': {
                    margin: '16px',
                    borderRadius: '8px',
                },
                ...sx,
            }}
        >
            <DialogContent sx={{ padding: '32px'}}>
                <Grid
                    container
                    justifyContent={'center'}
                    direction={'column'}
                    alignItems={'center'}
                    rowSpacing={2}
                >
                    <Grid item sx={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        padding: '12px !important',
                    }}>
                        {!hideCloseIcon && (
                            <CloseIcon
                                onClick={onClose}
                                style={{
                                    cursor: 'pointer',
                                }}
                            />
                        )}
                    </Grid>
                    <Grid item style={{
                        width: '88px',
                        textAlign: 'center'
                    }}>
                        {icon}
                    </Grid>
                    <Grid
                        item
                        container
                        justifyContent={'center'}
                        direction={'column'}
                        alignItems={isMobile ? "center" : "start"}
                        sx={{
                            textAlign: isMobile ? 'center' : "start"
                        }}
                    >
                        <Grid
                            item
                            sx={{
                                fontSize: '20px',
                                color: black500,
                                fontWeight: 600,
                            }}
                        >
                            {title}
                        </Grid>
                        <Grid
                            item
                            sx={{
                                fontSize: '16px',
                                color: greyishBlue500,
                            }}
                        >
                            {subtitle}
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{
                padding: '0 32px 32px 32px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
                {props.children}
            </DialogActions>
        </Dialog>
    );
}

export default Popup;
